import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacing.ion.large};
  border: 1px solid ${theme.colors.ion.state.enabled.soft};
  border-radius: ${theme.shapes.borderRadius.xm};
  padding: ${theme.spacing.md};
`

export const UploadedFileRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  border: 1px solid ${theme.colors.ion.state.enabled.soft};
  border-radius: ${theme.border.x8};
  padding: 0 ${theme.spacing.xs};
  width: 100%;
  height: 28px;
`

export const FileNameText = styled.span`
  font-size: ${theme.typography.sizes['2xs']};
  color: ${theme.colors.ion.neutral.stronger};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const HiddenInput = styled.input`
  display: none;
`
